const NTPI = 'NTPI'
const ITPSI = 'ITPSI'
const PP = 'PP'
const ITPSP = 'ITPSP'

export default {
    NTPI: NTPI,
    ITPSI: ITPSI,
    PP: PP,
    ITPSP: ITPSP,
}